export const GET_CONSULTANCIES_REQUEST = "GET_CONSULTANCIES_REQUEST";
export const GET_CONSULTANCIES_SUCCESS = "GET_CONSULTANCIES_SUCCESS";
export const GET_CONSULTANCIES_FAILURE = "GET_CONSULTANCIES_FAILURE";

export const GET_ALL_LOGBOOKS_REQUEST = "GET_ALL_LOGBOOKS_REQUEST"; 
export const GET_ALL_LOGBOOKS_SUCCESS = "GET_ALL_LOGBOOKS_SUCCESS"; 
export const GET_ALL_LOGBOOKS_FAILURE = "GET_ALL_LOGBOOKS_FAILURE"; 